module.exports = __webpack_public_path__ + "img/09.64f1af80.png";